import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, Fragment as _Fragment, createBlock as _createBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-center py-5"
}
const _hoisted_2 = {
  key: 1,
  class: "text-center py-5"
}
const _hoisted_3 = { class: "relative w-full h-[32rem]" }
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  key: 1,
  class: "flex items-center justify-center w-full h-full"
}
const _hoisted_6 = { class: "flex items-center justify-center p-3" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "text-center py-2 px-3" }
const _hoisted_9 = { class: "text-xl font-semibold m-0" }
const _hoisted_10 = { class: "text-sm m-3" }
const _hoisted_11 = ["href"]
const _hoisted_12 = { class: "text-center py-5" }

export function render(_ctx, _cache) {
  const _component_Button = _resolveComponent("Button")
  const _component_Toast = _resolveComponent("Toast")
  const _component_Step = _resolveComponent("Step")
  const _component_StepList = _resolveComponent("StepList")
  const _component_InputNumber = _resolveComponent("InputNumber")
  const _component_IftaLabel = _resolveComponent("IftaLabel")
  const _component_StepPanel = _resolveComponent("StepPanel")
  const _component_SelectButton = _resolveComponent("SelectButton")
  const _component_ProgressSpinner = _resolveComponent("ProgressSpinner")
  const _component_Card = _resolveComponent("Card")
  const _component_StepPanels = _resolveComponent("StepPanels")
  const _component_Stepper = _resolveComponent("Stepper")

  return false
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _cache[5] || (_cache[5] = _createElementVNode("h2", { class: "text-white text-xl font-bold" }, "อัปเดตบัญชี", -1 /* HOISTED */)),
        _cache[6] || (_cache[6] = _createElementVNode("p", { class: "text-white text-[12px] mt-2" }, "กรุณาอัปเดตบัญชี Peer2Pay", -1 /* HOISTED */)),
        _createVNode(_component_Button, {
          label: "อัปเดตบัญชี",
          onClick: _ctx.btnClickUpdateP2p,
          class: "mt-4",
          size: "small"
        }, null, 8 /* PROPS */, ["onClick"]),
        _createVNode(_component_Toast)
      ]))
    : (_openBlock(), _createBlock(_component_Stepper, {
        key: 1,
        value: _ctx.stepper,
        "onUpdate:value": _cache[4] || (_cache[4] = $event => ((_ctx.stepper) = $event)),
        linear: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_StepList, null, {
            default: _withCtx(() => [
              _createVNode(_component_Step, {
                value: "1",
                pt: {header: 'text-xs!', number: 'text-xs! size-6! min-w-auto!', title:'text-amber-100!'}
              }, {
                default: _withCtx(() => _cache[7] || (_cache[7] = [
                  _createTextVNode("ระบุจำนวนเงิน")
                ])),
                _: 1 /* STABLE */,
                __: [7]
              }),
              _createVNode(_component_Step, {
                value: "2",
                pt: {header: 'text-xs!', number: 'text-xs! size-6! min-w-auto!', title:'text-amber-100!'}
              }, {
                default: _withCtx(() => _cache[8] || (_cache[8] = [
                  _createTextVNode("ฝาก")
                ])),
                _: 1 /* STABLE */,
                __: [8]
              }),
              _createVNode(_component_Step, {
                value: "3",
                pt: {header: 'text-xs!', number: 'text-xs! size-6! min-w-auto!', title:'text-amber-100!'}
              }, {
                default: _withCtx(() => _cache[9] || (_cache[9] = [
                  _createTextVNode("สำเร็จ")
                ])),
                _: 1 /* STABLE */,
                __: [9]
              })
            ]),
            _: 1 /* STABLE */
          }),
          _createVNode(_component_StepPanels, { pt: {root: 'px-0!'} }, {
            default: _withCtx(() => [
              _createVNode(_component_StepPanel, {
                value: "1",
                pt: {root: 'bg-transparent!'}
              }, {
                default: _withCtx(() => [
                  (_ctx.isActive)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _cache[11] || (_cache[11] = _createElementVNode("div", { class: "bg-[#34513bd4]! border-4! border-[#34513b]! mb-3" }, [
                          _createElementVNode("p", { class: "text-white text-[12px]" }, "ฝากเงินผ่าน Peer2Pay สะดวก ปลอดภัยกว่า เพียงป้อนจำนวนเงิน และ คลิก ฝาก จากนั้นเข้าสู่ระบบ Peer2Pay เพื่อเชื่อมต่อกับ กระเป๋าเกม ทันที ( ฝากขั้นต่ำ 10 บาท สูงสุด 50,000 บาท )")
                        ], -1 /* HOISTED */)),
                        _createElementVNode("form", {
                          onSubmit: _cache[1] || (_cache[1] = _withModifiers((...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args)), ["prevent"]))
                        }, [
                          _createVNode(_component_IftaLabel, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_InputNumber, {
                                "input-id": "price_input",
                                modelValue: _ctx.form.amount,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.form.amount) = $event)),
                                min: _ctx.amountLimit.min,
                                max: _ctx.amountLimit.max,
                                mode: "currency",
                                currency: "THB",
                                locale: "th-TH",
                                class: "w-full",
                                "input-class": "bg-[#000000d9]! text-amber-100! border border-[#29ab60]!"
                              }, null, 8 /* PROPS */, ["modelValue", "min", "max"]),
                              _cache[10] || (_cache[10] = _createElementVNode("label", { for: "price_input" }, "ระบุจำนวนเงิน", -1 /* HOISTED */))
                            ]),
                            _: 1 /* STABLE */,
                            __: [10]
                          }),
                          _createVNode(_component_Button, {
                            label: "ฝาก",
                            type: "submit",
                            disabled: _ctx.form.btn.disabled,
                            loading: _ctx.form.btn.loading,
                            size: "small",
                            class: "min-w-20 mt-5"
                          }, null, 8 /* PROPS */, ["disabled", "loading"])
                        ], 32 /* NEED_HYDRATION */)
                      ], 64 /* STABLE_FRAGMENT */))
                    : (_openBlock(), _createElementBlock("div", _hoisted_2, _cache[12] || (_cache[12] = [
                        _createElementVNode("h2", { class: "text-amber-100 text-xl font-bold" }, "ปิดให้บริการชั่วคราว", -1 /* HOISTED */),
                        _createElementVNode("p", { class: "text-[12px] text-amber-100 mt-2" }, "ช่องทางฝากนี้ปิดให้บริการชั่วคราว กรุณาลองช่องทางอื่น ๆ", -1 /* HOISTED */)
                      ])))
                ]),
                _: 1 /* STABLE */
              }),
              _createVNode(_component_StepPanel, {
                value: "2",
                pt: {root: 'bg-transparent!'}
              }, {
                default: _withCtx(() => [
                  _cache[13] || (_cache[13] = _createElementVNode("div", { class: "bg-[#34513bd4]! border-4! border-[#34513b]! mb-3" }, [
                    _createElementVNode("p", { class: "text-white text-sm" }, [
                      _createTextVNode("คู่มือ Peer2pay ฝากถอนได้ง่ายผ่าน Peer2pay สะดวก ปลอดภัยกว่า หากยังไม่มีบัญชี Peer2Pay สมัครสมาชิกที่นี่ "),
                      _createElementVNode("a", {
                        href: "https://peertopay.com/auth/register/",
                        class: "underline text-amber-200 font-bold"
                      }, "สมัครสมาชิก Peer2pay")
                    ])
                  ], -1 /* HOISTED */)),
                  _createVNode(_component_SelectButton, {
                    modelValue: _ctx.form.type,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((_ctx.form.type) = $event)),
                    options: _ctx.options,
                    size: "small"
                  }, null, 8 /* PROPS */, ["modelValue", "options"]),
                  (_ctx.form.type === 'พื้นฐาน')
                    ? (_openBlock(), _createBlock(_component_Card, {
                        key: 0,
                        class: "w-full mx-auto mt-3",
                        pt: { header: 'flex justify-center', body: 'p-0!' }
                      }, {
                        content: _withCtx(() => [
                          _createElementVNode("div", _hoisted_3, [
                            (_ctx.bankDeposit.data.url)
                              ? (_openBlock(), _createElementBlock("iframe", {
                                  key: 0,
                                  src: _ctx.bankDeposit.data.url,
                                  class: "w-full h-full"
                                }, null, 8 /* PROPS */, _hoisted_4))
                              : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                  _createVNode(_component_ProgressSpinner, { style: {"width":"36px","height":"36px"} })
                                ]))
                          ])
                        ]),
                        _: 1 /* STABLE */
                      }))
                    : _createCommentVNode("v-if", true),
                  (_ctx.form.type === 'คิวอาโค้ด')
                    ? (_openBlock(), _createBlock(_component_Card, {
                        key: 1,
                        class: "w-full mx-auto mt-3",
                        pt: { header: 'flex justify-center', body: 'p-0!' }
                      }, {
                        header: _withCtx(() => [
                          _createElementVNode("div", _hoisted_6, [
                            (_ctx.bankDeposit.data.contentQr)
                              ? (_openBlock(), _createElementBlock("img", {
                                  key: 0,
                                  src: _ctx.bankDeposit.data.contentQr,
                                  class: "w-full",
                                  alt: "qrcode"
                                }, null, 8 /* PROPS */, _hoisted_7))
                              : (_openBlock(), _createBlock(_component_ProgressSpinner, {
                                  key: 1,
                                  style: {"width":"36px","height":"36px"}
                                }))
                          ])
                        ]),
                        footer: _withCtx(() => [
                          _createElementVNode("div", _hoisted_8, [
                            _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.bankDeposit.data.quantity) + " " + _toDisplayString(_ctx.bankDeposit.data.token), 1 /* TEXT */),
                            _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.bankDeposit.data.merchantName), 1 /* TEXT */)
                          ]),
                          _createElementVNode("a", {
                            href: _ctx.bankDeposit.data.url,
                            target: "_blank",
                            class: "block bg-primary text-white p-2 w-max rounded-lg mb-3 mx-auto"
                          }, "คลิกที่นี่!", 8 /* PROPS */, _hoisted_11)
                        ]),
                        _: 1 /* STABLE */
                      }))
                    : _createCommentVNode("v-if", true)
                ]),
                _: 1 /* STABLE */,
                __: [13]
              }),
              _createVNode(_component_StepPanel, {
                value: "3",
                pt: {root: 'bg-transparent!'}
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_12, [
                    _cache[14] || (_cache[14] = _createElementVNode("h2", { class: "text-green-600 text-xl font-bold" }, "เมื่อทำการโอนเงินเรียบร้อยแล้ว", -1 /* HOISTED */)),
                    _cache[15] || (_cache[15] = _createElementVNode("p", { class: "text-amber-100 mt-2" }, "ยอดเงินจะถูกเติมเข้า กระเป๋าเกม ภายใน 5 วินาที", -1 /* HOISTED */)),
                    _createVNode(_component_Button, {
                      label: "กลับหน้าหลัก",
                      onClick: _cache[3] || (_cache[3] = $event => (_ctx.stepper = '1')),
                      class: "mt-4"
                    })
                  ])
                ]),
                _: 1 /* STABLE */
              })
            ]),
            _: 1 /* STABLE */
          }),
          _createVNode(_component_Toast)
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["value"]))
}